import { useState, useEffect } from "react";
import { parseMessageContent, formatContent, TRUNCATE_THRESHOLD, TRUNCATE_PREVIEW } from "./WorkflowSessionMessages";
import styles from "./workflow.module.scss";

/** Message content with truncation support. Calls onParsed with sender info. */
const MessageBody = ({
  content,
  onParsed,
}: {
  content: string;
  onParsed?: (sender?: string, isSlack?: boolean) => void;
}) => {
  const [expanded, setExpanded] = useState(false);
  const { text: cleaned, sender, isSlack } = parseMessageContent(content);

  useEffect(() => {
    if (onParsed) onParsed(sender, isSlack);
  }, [sender, isSlack, onParsed]);

  if (!cleaned) return null;

  const isLong = cleaned.length > TRUNCATE_THRESHOLD;
  const displayText = isLong && !expanded ? cleaned.slice(0, TRUNCATE_PREVIEW) + "..." : cleaned;

  return (
    <div className={styles.messageContent}>
      {formatContent(displayText)}
      {isLong && (
        <button
          type="button"
          className={styles.showMoreBtn}
          onClick={() => setExpanded(prev => !prev)}
        >
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};

export default MessageBody;
